// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HoverableListItem_wrapper__3lQas","clickArea":"HoverableListItem_clickArea__2THy3","item":"HoverableListItem_item__1LTrc","spacer":"HoverableListItem_spacer__ffD4j"};